import Flickity from "flickity";

class ServicesCarousel {
  constructor(block) {
    this.block = block;
    this.servicesWrapper = block.querySelector(".services-carousel__services");
    this.previousButton = block.querySelector(
      ".services-carousel__button--previous",
    );
    this.nextButton = block.querySelector(".services-carousel__button--next");
    this.flickityInit();
    this.events();
  }

  events() {
    this.previousButton.addEventListener("click", () => this.flkty.previous());
    this.nextButton.addEventListener("click", () => this.flkty.next());
  }

  flickityInit() {
    this.flkty = new Flickity(this.servicesWrapper, {
      pageDots: false,
      autoPlay: true,
      wrapAround: true,
      prevNextButtons: false,
      // adaptiveHeight: true,
      resize: true,
      contain: true,
      imagesLoaded: true,
      cellAlign: "left",
    });
  }
}

export default ServicesCarousel;
